import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ReviveYourHtmlCode from "./sections/ReviveYourHtmlCode";
import IndustryCredentials from "./sections/IndustryCredentials";
import OurExpertise from "./sections/OurExpertise";
import ClinicalImpactByTheNumbers from "./sections/ClinicalImpactByTheNumbers";
import TheMatsyaJourney from "./sections/TheMatsyaJourney";
import GuestExperiences from "./sections/GuestExperiences";
import ReadyForATransformation from "./sections/ReadyForATransformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ReviveYourHtmlCode />
      <IndustryCredentials />
      <OurExpertise />
      <ClinicalImpactByTheNumbers />
      <TheMatsyaJourney />
      <GuestExperiences />
      <ReadyForATransformation />
      <Footer />
    </div>;
}